import React from 'react';
import { isDeletedUser, UserProfile } from '../../../types/api/UserProfile';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { Namespace } from '../../../translation/namespace';
import { Hyperlink } from '../../../components/atoms/Hyperlink';
import { DateFormat } from '../../../_lib/components/DateFormat';

type PageMetaInfoOverviewTerms = {
  contentDate?: string;
  author?: UserProfile;
};

export function PageMetaInfoOverviewTerms({ contentDate, author }: PageMetaInfoOverviewTerms) {
  const { t } = useSonTranslation('MetaInfo');
  const hasContent = contentDate || author;
  if (!hasContent) {
    return null;
  }

  return (
    <dl className="page-meta-info__list">
      {author && (
        <>
          <dt className="invisible">{`${t(`${Namespace.glossary}:author`)}: `}</dt>
          <dd className="meta-info__listelement font-bold-15-19 page-meta-info__person-and-date">
            {' '}
            {isDeletedUser(author) ? (
              author.profileName
            ) : (
              <Hyperlink to={author.profileLink.url} className="meta-info__name--link">
                {author.profileName}
              </Hyperlink>
            )}
            {author && contentDate && <span aria-hidden="true">{',\u00A0'}</span>}
          </dd>
        </>
      )}
      {contentDate && (
        <>
          <dt className="invisible">{`${t('createdOn')}: `}</dt>
          <dd className="meta-info__listelement font-bold-15-19 page-meta-info__person-and-date">
            <DateFormat date={contentDate} />
          </dd>
        </>
      )}
    </dl>
  );
}
